export const environment = {
  production: true,
  buildId: '3305768100921381',
  configFile: 'config.json',
};
